(() => {
  const verifiedSeries = new Set(["一襲柔光 A Soft Halo", "摩登畫報 Modern Pictorial", "城市慢步 Metropolitan Ease", "柔軟偏愛 A Soft Spot", "睡蓮變奏曲 Water Lily Variations", "風度日常 Everyday Poise", "冬日織趣 A Woven Winter", "璀璨日常 Effortless Radiance"]);
  const cache = new Map();
  const states = new WeakMap();
  const jobs = [];
  let active = 0;
  let queued = false;

  function fallback(title) {
    const match = title.match(/^“([^”]+)”\s*(.+)$/u);
    if (!match) return null;
    const parts = match[1].split(' • ');
    if (parts.length > 2 || !verifiedSeries.has(parts[0].trim())) return null;
    return { series: parts[0].trim(), color: (parts[1] || '').trim(), detail: match[2].trim() };
  }

  function productURL(link) {
    if (!link) return null;
    try {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin) return null;
      const match = url.pathname.match(/^(.*?)(?:\/collections\/[^/]+)?\/products\/([^/]+)\/?$/);
      if (!match) return null;
      url.pathname = match[1] + '/products/' + match[2];
      url.search = '?view=delain-name-data';
      url.hash = '';
      return { url: url.href, handle: decodeURIComponent(match[2]) };
    } catch (_) { return null; }
  }

  function pump() {
    while (active < 4 && jobs.length) {
      active++;
      jobs.shift()().finally(() => { active--; pump(); });
    }
  }

  function getData(product) {
    if (cache.has(product.url)) return cache.get(product.url);
    const promise = new Promise(resolve => {
      jobs.push(async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(product.url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Product name unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(doc.getElementById('delain-name-data').textContent);
          if (data.handle !== product.handle) throw new Error('Product mismatch');
          resolve(data);
        } catch (_) { resolve(null); }
        finally { clearTimeout(timer); }
      });
    });
    cache.set(product.url, promise);
    pump();
    return promise;
  }

  function wrapper(data) {
    const node = document.createElement('span');
    node.className = 'delain-product-name';
    const series = document.createElement('strong');
    series.className = 'delain-product-name__series';
    series.textContent = data.series;
    const detail = document.createElement('span');
    detail.className = 'delain-product-name__detail';
    detail.textContent = (data.color ? data.color + ' · ' : '') + data.detail;
    node.append(series, detail);
    return node;
  }

  function update(node, link, source) {
    const old = states.get(node);
    const rendered = node.querySelector('.delain-product-name');
    const title = source ? source.textContent.trim() : (rendered && old ? old.title : node.textContent.trim());
    const product = productURL(link);
    const key = product ? product.url : '';
    if (old && old.title === title && old.key === key && old.rendered === rendered) return;
    if (rendered) {
      if (source) rendered.remove();
      else node.textContent = title;
    }
    if (source) source.classList.remove('delain-cart-original-name');
    else node.classList.remove('delain-product-name-host');
    const state = { title, key, rendered: null };
    states.set(node, state);
    const apply = data => {
      if (!node.isConnected || states.get(node) !== state) return;
      if (source && source.textContent.trim() !== title) return;
      if (!source && !state.rendered && node.textContent.trim() !== title) return;
      if (!data || !data.series || !data.detail) return;
      const result = wrapper(data);
      if (source) {
        if (state.rendered) state.rendered.replaceWith(result);
        else node.append(result);
        source.classList.add('delain-cart-original-name');
        node.setAttribute('aria-label', title);
      } else {
        node.replaceChildren(result);
        node.classList.add('delain-product-name-host');
      }
      state.rendered = result;
    };
    apply(fallback(title));
    if (product) getData(product).then(data => {
      if (!data) return;
      const clean = value => typeof value === 'string' ? value.trim() : '';
      const names = { series: clean(data.series), color: clean(data.color), detail: clean(data.detail) };
      // Match Liquid: a populated series with no detail keeps the full title.
      if (names.series && !names.detail && states.get(node) === state) {
        if (source) {
          if (state.rendered) state.rendered.remove();
          source.classList.remove('delain-cart-original-name');
        } else {
          node.textContent = title;
          node.classList.remove('delain-product-name-host');
        }
        state.rendered = null;
      } else if (names.series && names.detail) apply(names);
    });
  }

  function refresh() {
    queued = false;
    document.querySelectorAll('.snize-title').forEach(node => {
      const link = node.closest('a[href]') || node.closest('.snize-product, .snize-ac-product')?.querySelector('a[href*="/products/"]');
      update(node, link, null);
    });
    document.querySelectorAll('[data-testid="corner-cowi-cart-item-title-anchor"]').forEach(link => {
      const source = link.querySelector('p');
      if (source) update(link, link, source);
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }
  function start() {
    refresh();
    new MutationObserver(schedule).observe(document.body, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['href']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
